/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { lazy } from 'react';

import { LazyLoadContainer } from './commonWidgetStyle';
import { WidgetLazyLoadWrapper } from '../utilities/widgetLazyLoadWrapper';
import { AnimatedLoadingPlaceholder } from '../animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import styled from 'styled-components';

const MapWidget = lazy(() => import('./mapWidget.jsx'));

export const RadarWidgetLazy = () => {
    return (
        <WidgetLazyLoadWrapper suspenseFallbackLoadingUI={<RadarMapWidgetLoadingUI />}>
            <MapWidget />
        </WidgetLazyLoadWrapper>
    );
};

const RadarMapWidgetLoadingUI = () => {
    return (
        <LazyLoadContainer>
            <AnimatedLoadingPlaceholder height='100%' radius={3} />
        </LazyLoadContainer>
    );
};